// iTRACE WMS — componenti UI industriali condivisi (brutalist, touch-first)
import React from "react";

const VARIANTS = {
  primary: "bg-[#FF4500] text-white border-2 border-[#FF4500] hover:bg-[#E03C00] active:translate-y-1",
  dark: "bg-zinc-900 text-white border-2 border-zinc-900 hover:bg-zinc-800 active:translate-y-1",
  ghost: "bg-white text-zinc-900 border-2 border-zinc-300 hover:border-zinc-900 active:translate-y-1",
  danger: "bg-white text-red-600 border-2 border-red-300 hover:border-red-600 active:translate-y-1",
  success: "bg-green-600 text-white border-2 border-green-600 hover:bg-green-700 active:translate-y-1",
};

export const WButton = ({ variant = "ghost", className = "", children, ...props }) => (
  <button
    className={`h-16 px-5 font-bold uppercase tracking-wide text-sm md:text-base flex items-center justify-center gap-2 select-none transition-colors disabled:opacity-40 disabled:pointer-events-none ${VARIANTS[variant]} ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const WInput = React.forwardRef(({ className = "", ...props }, ref) => (
  <input
    ref={ref}
    className={`h-14 w-full px-4 text-lg bg-white border-2 border-zinc-300 focus:border-[#FF4500] focus:outline-none focus:ring-0 font-medium text-zinc-900 placeholder:text-zinc-400 ${className}`}
    {...props}
  />
));

export const WField = ({ label, children, className = "" }) => (
  <div className={className}>
    <p className="text-xs tracking-[0.15em] uppercase font-bold text-zinc-500 mb-1.5">{label}</p>
    {children}
  </div>
);

export const WCard = ({ className = "", children, ...props }) => (
  <div className={`bg-white border border-zinc-300 ${className}`} {...props}>{children}</div>
);

export const WBadge = ({ tone = "zinc", className = "", children }) => {
  const tones = {
    zinc: "bg-zinc-100 text-zinc-700 border-zinc-300",
    orange: "bg-orange-50 text-[#E03C00] border-orange-300",
    green: "bg-green-50 text-green-700 border-green-300",
    red: "bg-red-50 text-red-700 border-red-300",
    dark: "bg-zinc-900 text-white border-zinc-900",
  };
  return <span className={`inline-flex items-center px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide border ${tones[tone]} ${className}`}>{children}</span>;
};

export const WModal = ({ open, onClose, title, children, wide = false }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-start md:items-center justify-center p-2 md:p-6 overflow-y-auto" onClick={onClose}>
      <div
        className={`bg-[#F5F5F4] border-2 border-zinc-900 shadow-[8px_8px_0px_#09090b] w-full ${wide ? "max-w-4xl" : "max-w-2xl"} my-4`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-zinc-950 text-white px-5 py-4 flex items-center justify-between">
          <h2 className="font-['Chivo'] font-black text-lg md:text-xl uppercase tracking-tight">{title}</h2>
          <button onClick={onClose} className="w-12 h-12 flex items-center justify-center text-2xl font-bold hover:bg-zinc-800" data-testid="wmodal-close">×</button>
        </div>
        <div className="p-4 md:p-6">{children}</div>
      </div>
    </div>
  );
};

export const WToggle = ({ options, value, onChange, testIdPrefix = "toggle" }) => (
  <div className="flex">
    {options.map((o) => (
      <button
        key={o.value}
        onClick={() => onChange(o.value)}
        data-testid={`${testIdPrefix}-${o.value}`}
        className={`h-14 px-4 flex-1 font-bold uppercase text-sm border-2 -ml-[2px] first:ml-0 transition-colors ${
          value === o.value ? "bg-zinc-900 text-white border-zinc-900 z-10 relative" : "bg-white text-zinc-500 border-zinc-300"
        }`}
      >
        {o.label}
      </button>
    ))}
  </div>
);
